<template>
  <div
    class="flex flex-col"
    :class="{ 'self-center text-center': align === 'center' }"
  >
    <h1 class="punchline">
      {{ title }}
    </h1>

    <RichText
      v-if="subtitle"
      class="heading-3 mt-8 md:max-w-[736px]"
      :class="{ [$style.clampSubtitle]: clampLines }"
      :rich-text="subtitle"
      style-variant="none"
    />

    <RevLink
      v-if="longSubtitle && clampLines"
      class="text-action-default-low heading-3 mt-8"
      data-test="content-hub-hero-show-more"
      @click="clampLines = false"
    >
      {{ i18n(translations.readMoreIntro) }}
    </RevLink>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import type { BasePageContentAPI } from '@backmarket/http-api/src/api-specs-content/models/base-page-content'
import type { RichText as RichTextType } from '@backmarket/http-api/src/api-specs-content/models/rich-text'
import RichText from '@backmarket/nuxt-layer-cms/RichText.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer'
import { RevLink } from '@ds/components/Link'

import translations from './ContentHubHeroSection.translations'

type ContentHubHeroSectionProps = {
  title: string
  subtitle?: RichTextType
  align?: BasePageContentAPI['align']
}

const props = withDefaults(defineProps<ContentHubHeroSectionProps>(), {
  subtitle: undefined,
  align: 'left',
})

const i18n = useI18n()

const TEXT_MAX_CHARACTERS = 230

const clampLines = ref(true)

const longSubtitle = computed(() => {
  if (!props.subtitle) return false

  return documentToPlainTextString(props.subtitle).length > TEXT_MAX_CHARACTERS
})
</script>

<style module>
.clampSubtitle > div {
  @apply line-clamp-3;
}
</style>
